define('OutSystems/ClientRuntime/PerformanceTracker',["require", "exports", "tslib", "./ApplicationInfo", "./Communication", "./Logger", "./Settings"], function (require, exports, tslib_1, ApplicationInfo, Communication, Logger, Settings) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.markRenderUpdate = exports.markLifecycleEnd = exports.markRenderStart = exports.markReadyEnd = exports.markReadyStart = exports.markDataFetchEnd = exports.markDataFetchStart = exports.markInitializeEnd = exports.markInitializeStart = exports.markScreenStart = exports.TracingAPI = exports.applyCorrelationHeader = exports.getCorrelationHeaders = exports.getCurrentNavState = exports.FetchType = void 0;
    var FetchType;
    (function (FetchType) {
        FetchType["Aggregate"] = "aggregate";
        FetchType["DataAction"] = "dataAction";
    })(FetchType || (exports.FetchType = FetchType = {}));
    var currentNavState = null;
    var pendingFetches = new Map();
    var nextPendingId = 0;
    function getCurrentNavState() {
        return currentNavState;
    }
    exports.getCurrentNavState = getCurrentNavState;
    var MODULE_NAME = "PerformanceTracker";
    function shouldTrackNavigation() {
        Logger.trace(MODULE_NAME, function () {
            return "shouldTrackNavigation enabled=".concat(Settings.EnvParam.PerformanceMonitoringReactiveEnabled, " ") +
                "samplingEnabled=".concat(Settings.EnvParam.PerformanceMonitoringReactiveSamplingEnabled, " ") +
                "sampleRate=".concat(Settings.EnvParam.PerformanceMonitoringReactiveSampleRate);
        });
        if (!Settings.EnvParam.PerformanceMonitoringReactiveEnabled) {
            return false;
        }
        if (Settings.EnvParam.PerformanceMonitoringReactiveSamplingEnabled) {
            if (Math.random() * 100 < Settings.EnvParam.PerformanceMonitoringReactiveSampleRate) {
                Logger.trace(MODULE_NAME, "sampling kept this navigation");
                return true;
            }
            else {
                Logger.trace(MODULE_NAME, "sampling dropped this navigation");
                return false;
            }
        }
        return true;
    }
    var CORRELATION_HEADER_NAME = "x-screen-requestkey";
    function getCorrelationHeaders() {
        var _a;
        if (!currentNavState) {
            return {};
        }
        return _a = {}, _a[CORRELATION_HEADER_NAME] = currentNavState.staticContext.RequestKey, _a;
    }
    exports.getCorrelationHeaders = getCorrelationHeaders;
    function applyCorrelationHeader(headers) {
        if (!currentNavState) {
            return headers;
        }
        return tslib_1.__assign(tslib_1.__assign({}, headers), getCorrelationHeaders());
    }
    exports.applyCorrelationHeader = applyCorrelationHeader;
    function initializeNavigation() {
        if (!shouldTrackNavigation()) {
            currentNavState = null;
            return;
        }
        var tNavStart = performance.now();
        currentNavState = {
            tNavStart: tNavStart,
            probeFetchCount: 0,
            lifecycleComplete: false,
            allFetchesComplete: true,
            pendingRender: false,
            totalEmitted: false,
            phaseStartTimes: new Map(),
            staticContext: resolveStableContext(),
        };
    }
    function resolveStableContext() {
        return {
            RequestKey: generateRequestKey(),
            ModuleKey: ApplicationInfo.getHomeModuleKey(),
            ModuleName: ApplicationInfo.getHomeModuleName(),
            ApplicationKey: ApplicationInfo.getApplicationKey(),
            ApplicationName: ApplicationInfo.getApplicationName(),
            Details: {
                EPK: null,
                EPN: null,
                EK: nullIfEmpty(ApplicationInfo.getEnvironmentKey()),
                EN: nullIfEmpty(ApplicationInfo.getEnvironmentName()),
                TK: null,
                TN: null,
                FN: null,
                VK: null,
                ViK: null,
                SK: null,
                UK: null,
                SR: resolveScreenResolution(),
                UA: resolveUserAgent(),
            },
        };
    }
    function nullIfEmpty(value) {
        return value ? value : null;
    }
    function resolveScreenResolution() {
        if (typeof window === "undefined" || !window.screen) {
            return null;
        }
        var width = window.screen.width;
        var height = window.screen.height;
        if (!width || !height) {
            return null;
        }
        return width + "x" + height;
    }
    function resolveUserAgent() {
        if (typeof navigator === "undefined") {
            return null;
        }
        return nullIfEmpty(navigator.userAgent);
    }
    function generateRequestKey() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = Math.floor(Math.random() * 16);
            var v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        });
    }
    var REQUEST_EVENTS_URL = "PerformanceProbe/rest/PerformanceMonitoringAPI/RequestEvents/";
    exports.TracingAPI = {
        send: function (event) {
            var d = event.Details;
            var orderedDetails = {
                AK: d.AK,
                AN: d.AN,
                EPK: d.EPK,
                EPN: d.EPN,
                TK: d.TK,
                TN: d.TN,
                EK: d.EK,
                EN: d.EN,
                FN: d.FN,
                VK: d.VK,
                ViK: d.ViK,
                SK: d.SK,
                UK: d.UK,
                SR: d.SR,
                D: d.D,
                LT: d.LT,
                TTFB: d.TTFB,
                TTLB: d.TTLB,
                UA: d.UA,
            };
            var wire = {
                Instant: new Date().toISOString(),
                RequestKey: event.RequestKey,
                RequestEventName: event.RequestEventName,
                ModuleKey: event.ModuleKey,
                ModuleName: event.ModuleName,
                ApplicationKey: event.ApplicationKey,
                ApplicationName: event.ApplicationName,
                RequestEventDetails: JSON.stringify(orderedDetails),
            };
            Logger.trace(MODULE_NAME, function () { return "sending ".concat(wire.RequestEventName, " to Tracing API: ").concat(JSON.stringify(wire)); });
            Communication.post(REQUEST_EVENTS_URL, wire).catch(function () {
            });
        },
    };
    var PhaseEventName;
    (function (PhaseEventName) {
        PhaseEventName["Initialize"] = "WebScreenInitializeExecuted";
        PhaseEventName["Ready"] = "WebScreenReadyExecuted";
        PhaseEventName["Aggregate"] = "WebScreenAggregateExecuted";
        PhaseEventName["DataAction"] = "WebScreenDataActionExecuted";
        PhaseEventName["Total"] = "WebScreenClientExecuted";
    })(PhaseEventName || (PhaseEventName = {}));
    var PhaseActionName;
    (function (PhaseActionName) {
        PhaseActionName["Initialize"] = "OnInitialize";
        PhaseActionName["Ready"] = "OnReady";
        PhaseActionName["Total"] = "WebScreenClient";
    })(PhaseActionName || (PhaseActionName = {}));
    var NO_FETCH_TIMING = { D: null, LT: null, TTFB: null, TTLB: null };
    function buildEvent(ns, eventName, actionName, actionKey, runtimeDuration, timing) {
        var _a;
        if (timing === void 0) { timing = NO_FETCH_TIMING; }
        var ctx = ns.staticContext;
        return {
            RequestKey: ctx.RequestKey,
            RequestEventName: eventName,
            ModuleKey: ctx.ModuleKey,
            ModuleName: ctx.ModuleName,
            ApplicationKey: ctx.ApplicationKey,
            ApplicationName: ctx.ApplicationName,
            Details: {
                D: (_a = timing.D) !== null && _a !== void 0 ? _a : runtimeDuration,
                EPK: ctx.Details.EPK,
                EPN: ctx.Details.EPN,
                AN: actionName,
                AK: nullIfEmpty(actionKey),
                EK: ctx.Details.EK,
                EN: ctx.Details.EN,
                TK: ctx.Details.TK,
                TN: ctx.Details.TN,
                FN: ctx.Details.FN,
                VK: ctx.Details.VK,
                ViK: ctx.Details.ViK,
                SK: ctx.Details.SK,
                UK: ctx.Details.UK,
                SR: ctx.Details.SR,
                UA: ctx.Details.UA,
                LT: timing.LT,
                TTFB: timing.TTFB,
                TTLB: timing.TTLB,
            },
        };
    }
    function resolveFetchTiming(pending) {
        if (typeof performance === "undefined" || typeof performance.getEntriesByType !== "function") {
            return NO_FETCH_TIMING;
        }
        var entries = performance.getEntriesByType("resource");
        var entry = null;
        for (var i = 0; i < entries.length; i++) {
            var e = entries[i];
            if (e.name.indexOf(pending.url) !== -1 && e.startTime >= pending.startTime - 5) {
                entry = e;
                break;
            }
        }
        if (!entry) {
            return NO_FETCH_TIMING;
        }
        var ttlb = Math.round(entry.responseEnd - entry.requestStart);
        var lt = Math.round(performance.now() - entry.responseEnd);
        return {
            TTFB: Math.round(entry.responseStart - entry.requestStart),
            TTLB: ttlb,
            LT: lt,
            D: lt + ttlb,
        };
    }
    function sendPhaseEvent(ns, eventName, actionName, actionKey) {
        var start = ns.phaseStartTimes.get(actionName);
        if (start === undefined) {
            return;
        }
        var duration = Math.round(performance.now() - start);
        exports.TracingAPI.send(buildEvent(ns, eventName, actionName, actionKey, duration));
    }
    function maybeEmitTotal(ns) {
        if (!ns.lifecycleComplete || !ns.allFetchesComplete || ns.pendingRender || ns.totalEmitted) {
            return;
        }
        ns.totalEmitted = true;
        var duration = Math.round(performance.now() - ns.tNavStart);
        exports.TracingAPI.send(buildEvent(ns, PhaseEventName.Total, PhaseActionName.Total, null, duration));
    }
    function withCurrentNav(fn) {
        return currentNavState ? fn(currentNavState) : null;
    }
    function resolveScreenContext(ns, controller) {
        var viewName = controller.modelContext ? controller.modelContext.viewName : null;
        if (!viewName) {
            return;
        }
        var moduleDefinition = ApplicationInfo.getHomeModuleDefinition();
        if (!moduleDefinition) {
            return;
        }
        var screen = ApplicationInfo.getScreenDefinitionFromScreenName(moduleDefinition, viewName);
        if (!screen) {
            return;
        }
        ns.staticContext.Details.EPK = nullIfEmpty(screen.screenKey);
        ns.staticContext.Details.EPN = nullIfEmpty(screen.screenName);
    }
    function markScreenStart(controller) {
        Logger.trace(MODULE_NAME, "markScreenStart");
        initializeNavigation();
        withCurrentNav(function (ns) {
            resolveScreenContext(ns, controller);
        });
    }
    exports.markScreenStart = markScreenStart;
    function markInitializeStart() {
        Logger.trace(MODULE_NAME, "markInitializeStart");
        withCurrentNav(function (ns) {
            ns.phaseStartTimes.set(PhaseActionName.Initialize, performance.now());
        });
    }
    exports.markInitializeStart = markInitializeStart;
    function markInitializeEnd(actionKey) {
        if (actionKey === void 0) { actionKey = null; }
        Logger.trace(MODULE_NAME, "markInitializeEnd");
        withCurrentNav(function (ns) { return sendPhaseEvent(ns, PhaseEventName.Initialize, PhaseActionName.Initialize, actionKey); });
    }
    exports.markInitializeEnd = markInitializeEnd;
    function markDataFetchStart(name, actionKey, type, url) {
        return withCurrentNav(function (ns) {
            Logger.trace(MODULE_NAME, function () { return "markDataFetchStart ".concat(JSON.stringify({ name: name, type: type, url: url })); });
            var pendingId = nextPendingId++;
            pendingFetches.set(pendingId, {
                navState: ns,
                name: name,
                type: type,
                startTime: performance.now(),
                actionKey: actionKey,
                url: url,
            });
            ns.probeFetchCount++;
            ns.allFetchesComplete = false;
            return pendingId;
        });
    }
    exports.markDataFetchStart = markDataFetchStart;
    function markDataFetchEnd(pendingId) {
        if (pendingId === null && currentNavState && currentNavState.totalEmitted) {
            return;
        }
        if (pendingId === null) {
            return;
        }
        Logger.trace(MODULE_NAME, function () { return "markDataFetchEnd ".concat(JSON.stringify({ pendingId: pendingId })); });
        var pending = pendingFetches.get(pendingId);
        if (!pending) {
            return;
        }
        pendingFetches.delete(pendingId);
        var navState = pending.navState;
        var eventName = pending.type === FetchType.Aggregate ? PhaseEventName.Aggregate : PhaseEventName.DataAction;
        var duration = Math.round(performance.now() - pending.startTime);
        exports.TracingAPI.send(buildEvent(navState, eventName, pending.name, pending.actionKey, duration, resolveFetchTiming(pending)));
        navState.pendingRender = true;
        navState.probeFetchCount--;
        if (navState.probeFetchCount === 0) {
            setTimeout(function () {
                if (navState.probeFetchCount === 0 && !navState.allFetchesComplete) {
                    navState.allFetchesComplete = true;
                    maybeEmitTotal(navState);
                }
            }, 0);
        }
    }
    exports.markDataFetchEnd = markDataFetchEnd;
    function markReadyStart() {
        Logger.trace(MODULE_NAME, "markReadyStart");
        withCurrentNav(function (ns) { return ns.phaseStartTimes.set(PhaseActionName.Ready, performance.now()); });
    }
    exports.markReadyStart = markReadyStart;
    function markReadyEnd(actionKey) {
        if (actionKey === void 0) { actionKey = null; }
        Logger.trace(MODULE_NAME, "markReadyEnd");
        withCurrentNav(function (ns) { return sendPhaseEvent(ns, PhaseEventName.Ready, PhaseActionName.Ready, actionKey); });
    }
    exports.markReadyEnd = markReadyEnd;
    function markRenderStart() {
        Logger.trace(MODULE_NAME, "markRenderStart");
    }
    exports.markRenderStart = markRenderStart;
    function markLifecycleEnd() {
        Logger.trace(MODULE_NAME, "markLifecycleEnd");
        withCurrentNav(function (ns) {
            ns.lifecycleComplete = true;
            maybeEmitTotal(ns);
        });
    }
    exports.markLifecycleEnd = markLifecycleEnd;
    function markRenderUpdate() {
        if (currentNavState && currentNavState.totalEmitted) {
            return;
        }
        Logger.trace(MODULE_NAME, "markRenderUpdate");
        withCurrentNav(function (ns) {
            ns.pendingRender = false;
            maybeEmitTotal(ns);
        });
    }
    exports.markRenderUpdate = markRenderUpdate;
});
//# sourceMappingURL=PerformanceTracker.js.map;
